import { useSendComment } from './use-send';
import { useDeleteComment } from './use-delete';
import { useFetchComments } from './use-fetch';

import type { IUseCommentProps } from './types';

export const useComment = (props: IUseCommentProps) => {
  const { patientGuid, meta: metaProps, enabled = true } = props;

  const {
    data,
    isLoading,
    meta,
    setMeta,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFetchComments({ patientGuid, meta: metaProps, enabled });

  const { sendComment, loading: isSending } = useSendComment();
  const { deleteComment, loading: isDeleting } = useDeleteComment();

  return {
    data,
    meta,
    setMeta,
    refetch,
    sendComment,
    deleteComment,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isSending,
    isDeleting,
    isFetchingNextPage,
  };
};
